<template>
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <g stroke-linecap="round" stroke-width="3" stroke="currentColor" fill="none" stroke-linejoin="round">
      <path d="M.75 23.25L23.25.75" />
      <path d="M23.25 23.25L.75.75" />
    </g>
  </svg>
</template>
